import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled from "styled-components";
import { Button, Spinner } from "~/components-shared";
const Wrapper = styled.div`
  display: inline-block;
  position: relative;
  z-index: 3;
  ${_ref => {
  let {
    $s,
    theme
  } = _ref;
  return theme.spacing.resolve(theme, $s);
}};

  & > * {
    &:not(:first-child) {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;

      &:before {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
    &:not(:last-child) {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;

      &:before {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
  }
`;
const ButtonGroup = _ref2 => {
  let {
    selected,
    options,
    s,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $s: s
  }, rest), options.map(button => /*#__PURE__*/React.createElement(Button, {
    key: button.id,
    onClick: () => button.onClick(button.id),
    display: "inline-block",
    color: selected === button.id ? "translucentPrimary" : "translucent",
    fontSize: 3.5,
    s: {
      px: 4,
      py: 2
    },
    pulse: button.inProgress,
    outline: false
  }, button.inProgress && /*#__PURE__*/React.createElement(Spinner, {
    scale: 4,
    s: {
      mr: 1.5
    }
  }), button.title, !!button.count && ` (${button.count})`)));
};
export default ButtonGroup;